import { ApplicationConfig, EnvironmentProviders, Provider, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { authInterceptor } from './common/services/auth.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CSRF_COOKIE } from './common/consts/app.const';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';

const providers: Array<Provider | EnvironmentProviders> = [
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
  provideClientHydration(),
  provideAnimationsAsync(),
  provideHttpClient(
    withFetch(),
    withInterceptorsFromDi(),
    withXsrfConfiguration({
      cookieName: CSRF_COOKIE,
      headerName: 'x-csrf-token',
    }),
    withInterceptors([
      authInterceptor,
    ]),
  ),
];


export const appConfig: ApplicationConfig = {
  providers,
};
